import React from 'react';
import type {BoxProps, HeadingProps} from '@tempo/core';
import {Flex, Heading, Link, Text, VStack} from '@tempo/core';

type FormSectionTitleProps = {
	title: string | React.ReactElement;
	subtitle?: React.ReactNode;
	subLink?: string;
	titleProps?: HeadingProps;
	rightElements?: React.ReactElement;
} & Omit<BoxProps, 'title'>;

const FormSectionTitle = ({
	title,
	subtitle,
	subLink,
	titleProps,
	rightElements,
	...props
}: FormSectionTitleProps) => {
	return (
		<Flex
			justifyContent="space-between"
			pt={{base: 0, md: 'spacing.xl'}}
			alignItems="center"
			{...props}
		>
			<VStack alignItems="initial" spacing="spacing.xs" flex={1} {...props}>
				<Heading as="h1" variant={'heading.s'} {...titleProps}>
					{title}
				</Heading>
				{subtitle && !subLink ? (
					<Text color="text.neutral.secondary.default" variant="caption.strong">
						{subtitle}
					</Text>
				) : (
					<Link
						data-testid="support-link"
						href={subLink}
						isExternal={true}
						variant="deezer"
					>
						<Text variant="caption.strong">{subtitle}</Text>
					</Link>
				)}
			</VStack>
			{rightElements}
		</Flex>
	);
};

export default FormSectionTitle;
